<template>
  <div v-if="isAndroid" class="back-button" @click="onClick">
    <van-icon size="25px" name="arrow-left" />
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClick() {
      if (this.tag) {
        this.$router.push("/");
      } else {
        this.$router.go("-1");
      }
    },
  },
  computed: {
    isAndroid() {
      if (navigator.userAgent && navigator.userAgent.indexOf("Android") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.back-button {
  position: fixed;
  top: 5px;
  left: 10px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #fff;
  background: rgb(0 0 0 / 50%);
  border-radius: 10px;
}
</style>
